import { styled } from "themes"

export const RelatedCaseStudiesWrapper = styled.section`
  padding-top: 40px;
  padding-bottom: 100px;
  background: #f6f7fa;
  margin-top: -50px;
`
